import type { TOC } from '@ember/component/template-only';

interface S {
  Args: {
    value: string | number | undefined;
    valueStyles?: string;
    unit: string;
    /**
     * defaults to 'ui inverted black text'
     *
     * pass an empty string ('') if you don't need unit styles
     * */
    unitStyles?: string;
  };
}

function getUnitStyles(argsUnitStyles) {
  return argsUnitStyles ?? 'ui inverted black text';
}

/*
❗ Watch out, white spaces in this template are important to preserve the
non-breaking space

DO NOT add new lines in the template
*/
/** Renders a value and its unit attached with a non-breaking space since
 * a value and its unit should never be appart
 *
 * Optionnaly, you can pass styles for either the value or the unit
 */
const ValueWithUnit: TOC<S> = <template>
  {{#let (getUnitStyles @unitStyles) as |unitStyles|}}
    {{#if @valueStyles}}<span
        data-test-value-styles
        class={{@valueStyles}}
      >{{@value}}</span>{{else}}{{@value}}{{/if}}&nbsp;{{#if unitStyles}}<span
        data-test-unit-styles
        class={{unitStyles}}
      >{{@unit}}</span>{{else}}{{@unit}}{{/if}}
  {{/let}}
</template>;

export default ValueWithUnit;
